export default "__VITE_ASSET__xjQT_DK9__"